module.exports = __webpack_public_path__ + "static/people-labs-logo-645e3abb364df6aced53640db129cf4d.gif";